import * as React from 'react';
import { ReactComponent as PlaceholderAvatarIconSVG } from '../../assets/icons/mevo/ic_placeholder_avatar.svg';
import IconPattern, { IconProps } from './_IconPattern';

const PlaceholderAvatarIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={PlaceholderAvatarIconSVG} variantPlaces={3} {...props} />;
};

export default PlaceholderAvatarIcon;
